import { asList } from 'shared/utilities/format';

export function listItems(data) {
  return asList(data);
}

export function listMeta(data) {
  return data?.meta || { current_page: 1, last_page: 1, per_page: 20, total: asList(data).length };
}

export function isoFromDatetimeLocal(value) {
  if (!value) {
    return undefined;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
}

export function datetimeLocalFromIso(value) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const pad = (part) => String(part).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export const TIMEZONES = typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function'
  ? Intl.supportedValuesOf('timeZone')
  : ['Asia/Riyadh', 'Asia/Dubai', 'Africa/Cairo', 'Europe/London', 'UTC'];
